import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {ApiDataSource} from "../../utils/api-data-source";
import {AppService} from "../../app.service";
import {ApiRequestService} from "../api-request.service";
import {UtilsService} from "../utils.service";
import {tap} from "rxjs/operators";
import {AccountTagsEditComponent} from "../../account/account-tags-edit/account-tags-edit.component";
import {TagModel} from "../../models/tag.model";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-tags-selector',
  templateUrl: './tags-selector.component.html',
  styleUrls: ['./tags-selector.component.scss']
})
export class TagsSelectorComponent implements OnInit {

  // columns to show and the data source
  displayedColumns: string[] = [
    'select',
    'id',
    'title',
    'description',
    'date_created'
  ];
  dataSource: TagsSelectorDataSource;
  returnAllSelected = false;

  // the paginator and sorter
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public app: AppService,
    private api: ApiRequestService,
    public utils: UtilsService,
    public dialogRef: MatDialogRef<TagsSelectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // set multiple if it is not present to false
    if (typeof this.data['multiple'] === 'undefined') {
      this.data['multiple'] = false;
    }

    // construct the datasource
    this.dataSource = new TagsSelectorDataSource(
      this.app,
      this.api,
      this.data['multiple']
    );

    // set a default selection of nothing if no selected values are passed through
    if (typeof this.data['selected'] === 'undefined') {
      this.data['selected'] = [];
    }

    // loop and select the values
    for (let i = 0; i < this.data['selected'].length; i++) {
      if (this.data['selected'][i]) {
        this.dataSource.selection.select(this.data['selected'][i]);
      }
    }

    this.returnAllSelected = this.data.returnAllSelected;
  }

  ngOnInit() {
    this.dataSource.getData();
  }

  ngAfterViewInit() {
    // Reset the paginator when sorting
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    const _tap = tap(() => {
      this.dataSource.limit = this.paginator.pageSize;
      this.dataSource.offset = this.paginator.pageIndex;
      this.dataSource.order_by = this.sort.active;
      this.dataSource.order = this.sort.direction;

      // Sort UTC by its corresponding date column.
      if ( this.sort.active == 'date_created_UTC' ) {
        this.dataSource.order_by = 'date_created';
      }

      this.dataSource.getData(false);
    });

    // Subscribe to the paginator tap events
    this.paginator.page.pipe(_tap).subscribe();
    this.sort.sortChange.pipe(_tap).subscribe();
  }

  // clears the search bar and performs a search
  onClearSearch() {
    // clear the search field in the datasource
    this.dataSource.search = '';
    // search for records
    this.dataSource.getData(true);
  }

  onClearSelected() {
    this.dataSource.selection.clear();
  }

  /**
   * before the dialog close we want to store the new active tag id
   */
  onSaveAndClose() {
    if (this.returnAllSelected) {
      return this.dialogRef.close({
        selected: this.dataSource.selection.selected,
        isAllSelected: this.dataSource.isAllSelected()
      });
    }

    let response: number | number[];

    if (this.data['multiple']) {
      response = this.dataSource.selection.selected;
    } else {
      if (this.dataSource.selection.selected.length) {
        response = this.dataSource.selection.selected[0];
      } else {
        response = 0;
      }
    }

    this.dialogRef.close(response);
  }

  onCreateNewTag() {
    // Create a new tool.
    this.utils.showComponentDialog(AccountTagsEditComponent, new TagModel(), {
      width: '900px'
    })
      .then((response) => {
        // Check if the response is a tool with an id
        if ( response && typeof response.id != 'undefined' && response.id ) {
          this.dataSource.selection.select(response.id);
        }

        // Refresh the tools selector list.
        this.dataSource.getData();
      });
  }

  onClose() {
    this.dialogRef.close();
  }

}

export class TagsSelectorDataSource extends ApiDataSource {
  order_by = 'title';
  order = 'asc';
  searchBy = 'title';

  getData(resetOffset: boolean = false) {
    this.makeRequest('v2/tags', resetOffset, {
      searchBy: this.searchBy,
      include_archived: false
    });
  }
}
